import { render, staticRenderFns } from "./AccountAuditDetailModal.vue?vue&type=template&id=b2a8e2c0&scoped=true&"
import script from "./AccountAuditDetailModal.vue?vue&type=script&lang=ts&"
export * from "./AccountAuditDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./AccountAuditDetailModal.vue?vue&type=style&index=0&id=b2a8e2c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a8e2c0",
  null
  
)

export default component.exports